<template>
    <div id="teamInviteUserPage" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="open" class="container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 m-auto text-center d-flex flex-column">
                    <div class="header mb-3">
                        <h3 class="m-auto">{{ $t('team.invite_user_title') }}</h3>
                        <a @click.prevent="hide();btnSfx();" href="#" class="close"></a>
                    </div>

                    <div class="d-flex justify-content-center my-4">
                        <img src="/images/home/teams/search-team-bg.png" class="vh-10" />
                    </div>

                    <h5 class="text-orange mb-0" v-html="$t('team.invite_user_desc')"></h5>
                    <div><hr style="width: 3em;"/></div>

                    <div class="form-group mb-3 pl-3 pr-3 pl-md-5 pr-md-5">
                        <label for="userName" class="mb-3">{{ $t('team.invite_user_search_label') }}</label>
                        <b-form-input v-model="name" debounce="500" id="userName" type="text" class="green-b text-center" size="lg"></b-form-input>
                    </div>

                    <p class="text-primary">{{ $t("team.invite_user_list_label") }}</p>

                    <div class="create-request-list">
                        <ul v-if="users.length > 0" class="team-users-list">
                            <li v-for="r in users" :key="r.id">
                                <img :src="r.avatarUrl != undefined ? r.avatarUrl : '/images/male-default.png'" alt="User image"/>
                                <h5 class="mb-0 ml-3">{{ r.username }}</h5>
                                <div class="team-users-list__right">
                                    <span class="addUser">
                                        <b-button @click="sendInvitation(r);btnSfx();" size="sm" variant="success">
                                            <img src="/images/icon-add-user.png"/>
                                        </b-button>
                                    </span>
                                </div>
                            </li>
                        </ul>
                        <div v-else class="d-flex flex-fill p-3">
                            <span class="text-primary m-auto" v-html="$t('team.invite_user_list_empty')"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'

import api from '../../api'


const InviteUserPopup = Vue.component('team-invite-user-popup', {
    data() {
        return {
            open: false,
            name: "",
            users: [],
            searched: null,
        }
    },
    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show() {
            this.open = true;
            this.name = "";
            this.users = [];
            this.searched = null;
        },
        
        hide() {
            this.open = false;
        }, 

        search() {
            const $this = this;

            // same search
            if(this.searched == this.name.trim()) 
                return;

            // clear list
            this.users = [];

            // if empty string 
            if(this.name.trim() == "") 
                return;

            api.usersWithoutTeam(this.name.trim()).then(res => {
                $this.users = res.data;
                $this.searched = $this.name.trim();
            })
            .catch(err => {
                api.baseErrorHendler(err);
            });
        },

        sendInvitation(user) {
            const $this = this;
            api.teamCreateIvitation(user.id)
            .then(res => {
                $this.hide();
                $this.$root.$bvModal.msgBoxOk($this.$t('team.invite_send_popup_text'), {
                    title: $this.$t('team.invite_send_popup_title'),
                    size: 'sm',
                    buttonSize: 'lg',
                    okTitle: $this.$t('base.btn_ok'),
                    modalClass: 'confirmModal',
                    hideHeaderClose: false,
                    centered: true
                }).then(r => {
                    $this.$store.dispatch('sound/sfx','Button');
                }); 
            })
            .catch(err => {
                api.baseErrorHendler(err);
            });
        },
    },
    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        },
        name(){
            if(this.open) 
                this.search();
        }
    }
})

export default InviteUserPopup
</script>